export const PAGE_LOAD_TIMESTAMP = Date.now();
